import { CardSubtitle } from "../../types/CoreComponents";

export const BasicSliderData: CardSubtitle[] = [
  {
    text: "Use the ",
    code: ".range-slider ",
  },
  {
    text: "class. and Zono used Ion range slider.",
    code: "[https://www.npmjs.com/package/react-range]",
  },
];
